import React, { useEffect, useState } from "react";
import './RegistroVisitantesSalidas.scss'
import HeaderVisitantes from "../../../../components/molecules/HeaderVisitantes/HeaderVisitantes";
import GlobalCard from "../../../../components/atoms/GlobalCard/GlobalCard";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import InputText from "../../../../components/atoms/InputText/InputText";
import lupa from '../../../../assets/icons/lupa.svg'
import { Button } from "primereact/button";
import { finalizarUsuario, getSalidas } from "./integracion";
import Swal from "sweetalert2";
const RegistroVisitantesSalidas = () => {
    const [data, setData] = useState([])
    const [globalFilter, setGlobalFilter] = useState('');
    useEffect(() => {
        getSalidas(setData)

    }, [])
    const header = (
        <div style={{ textAlign: 'left' }}>
            <div className="inputContenedor">
                <div className="contenedor">
                    <div className="fondo">
                        <img src={lupa} alt="" />
                    </div>
                    <InputText type="search" onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar" title=""></InputText>
                </div>
                <div >número de visitas :<span className="visitas"> {data.length}</span></div>
            </div>
        </div>
    );

    const botonSalir = (rowData) => {
        return (
            <div className="ButtonSalirContainer">
                <button className="botonSalir" onClick={() => { sacarUsuario(rowData.id) }}>Salir</button>
            </div>
        )
    }
    const sacarUsuario = (id) => {
        Swal.fire({
            title: "Desea finalizar la visita de este usuario",
            showDenyButton: true,
            confirmButtonText: "Confirmar",
            denyButtonText: `Cancelar`
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                finalizarUsuario(id,setData)
                Swal.fire("Usuario Finalizado!", "", "success");


            } else if (result.isDenied) {
                Swal.fire("Cambios no aplicados", "", "info");
            }
        });
    }


    return (
        <div className="RegistroVisitantesSalidas">
            <HeaderVisitantes seccion={"2"}></HeaderVisitantes>
            <div className="contenedorTabla">
                <GlobalCard>
                    <div className="titulo">Salidas de visita</div>
                    <hr />
                    <DataTable
                        value={data}
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 20]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        header={header}
                        scrollable
                        scrollHeight="calc(100vh - 350px)"
                        globalFilter={globalFilter}
                        emptyMessage="No records found"
                        className="tabla-visitas"
                    >
                        <Column field="id" header="ID" sortable />
                        <Column field="nombre" header="NOMBRE" sortable />
                        <Column field="unidad" header="UNIDAD" sortable />
                        <Column field="fecha" header="FECHA" sortable />
                        <Column field="area" header="AREA" sortable />
                        <Column field="category" header="SALIR" body={botonSalir} sortable />
                        {/* Add more columns as needed */}
                    </DataTable>
                </GlobalCard>
            </div>
        </div>
    )
}
export default RegistroVisitantesSalidas